import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Badge, Tooltip } from '@mui/material'
import QueueIcon from '@mui/icons-material/Queue'

import { useGetPatientQueueByStaffQuery } from '@/core/services/patient-queue'
import { PatientQueueModal } from '@/features/patient/patient-queue'

import { HeaderIconButton } from './HeaderIconButton'

export function PatientQueueButton() {
  const { t } = useTranslation()

  const { data: patientQueue } = useGetPatientQueueByStaffQuery()

  const [open, setOpen] = useState(false)

  const totalPatientsInQueue = useMemo(() => {
    return patientQueue?.queue.length
  }, [patientQueue])

  return (
    <>
      <Tooltip title={t('layouts.main.header.openPatientQueueButton.tooltip')}>
        <HeaderIconButton color="secondary" onClick={() => setOpen(true)} aria-label={t('layouts.main.header.openPatientQueueButton.tooltip')}>
          <Badge badgeContent={totalPatientsInQueue} color="error" max={99}>
            <QueueIcon />
          </Badge>
        </HeaderIconButton>
      </Tooltip>
      <PatientQueueModal open={open} onClose={() => setOpen(false)} />
    </>
  )
}
